import { IReferralSystem } from "../../../../../redux/type";
import { LOYALTY_PROGRAM_FIELDS } from "../../../../../redux/fields";
import dateToFormat from "../../../../../../../services/adapters.service/dateToFormat";

const convertMyReferralSystem = (props: any): IReferralSystem => {
	const data = props || {};

	return {
		[LOYALTY_PROGRAM_FIELDS.AFFILIATE]: data[LOYALTY_PROGRAM_FIELDS.AFFILIATE]
			? {
					[LOYALTY_PROGRAM_FIELDS.ID]:
						data[LOYALTY_PROGRAM_FIELDS.AFFILIATE]?.[
							LOYALTY_PROGRAM_FIELDS.ID
						] || 0,
					[LOYALTY_PROGRAM_FIELDS.FIRSTNAME]:
						data[LOYALTY_PROGRAM_FIELDS.AFFILIATE]?.[
							LOYALTY_PROGRAM_FIELDS.FIRSTNAME
						] || null,
					[LOYALTY_PROGRAM_FIELDS.SURNAME]:
						data[LOYALTY_PROGRAM_FIELDS.AFFILIATE]?.[
							LOYALTY_PROGRAM_FIELDS.SURNAME
						] || null,
					[LOYALTY_PROGRAM_FIELDS.PATRONYMIC]:
						data[LOYALTY_PROGRAM_FIELDS.AFFILIATE]?.[
							LOYALTY_PROGRAM_FIELDS.PATRONYMIC
						] || null,
					[LOYALTY_PROGRAM_FIELDS.EMAIL]:
						data[LOYALTY_PROGRAM_FIELDS.AFFILIATE]?.[
							LOYALTY_PROGRAM_FIELDS.EMAIL
						] || "",
			  }
			: null,
		[LOYALTY_PROGRAM_FIELDS.EVENTS]:
			data[LOYALTY_PROGRAM_FIELDS.EVENTS]?.map((event: any) => ({
				[LOYALTY_PROGRAM_FIELDS.REFERRAL]: {
					[LOYALTY_PROGRAM_FIELDS.ID]:
						event[LOYALTY_PROGRAM_FIELDS.REFERRAL]?.[
							LOYALTY_PROGRAM_FIELDS.ID
						] || 0,
					[LOYALTY_PROGRAM_FIELDS.FIRSTNAME]:
						event[LOYALTY_PROGRAM_FIELDS.REFERRAL]?.[
							LOYALTY_PROGRAM_FIELDS.FIRSTNAME
						] || null,
					[LOYALTY_PROGRAM_FIELDS.SURNAME]:
						event[LOYALTY_PROGRAM_FIELDS.REFERRAL]?.[
							LOYALTY_PROGRAM_FIELDS.SURNAME
						] || null,
					[LOYALTY_PROGRAM_FIELDS.PATRONYMIC]:
						event[LOYALTY_PROGRAM_FIELDS.REFERRAL]?.[
							LOYALTY_PROGRAM_FIELDS.PATRONYMIC
						] || null,
					[LOYALTY_PROGRAM_FIELDS.EMAIL]:
						event[LOYALTY_PROGRAM_FIELDS.REFERRAL]?.[
							LOYALTY_PROGRAM_FIELDS.EMAIL
						] || "",
				},
				[LOYALTY_PROGRAM_FIELDS.MORE_INFO]:
					event[LOYALTY_PROGRAM_FIELDS.MORE_INFO] || null,
				[LOYALTY_PROGRAM_FIELDS.STATUS]:
					event[LOYALTY_PROGRAM_FIELDS.STATUS] || "",
				[LOYALTY_PROGRAM_FIELDS.DATE]: event[LOYALTY_PROGRAM_FIELDS.DATE] || "",
				[LOYALTY_PROGRAM_FIELDS.DATE_FORMATTED]: dateToFormat(
					event[LOYALTY_PROGRAM_FIELDS.DATE]
				),
			})) || null,
		[LOYALTY_PROGRAM_FIELDS.ME]: {
			[LOYALTY_PROGRAM_FIELDS.CAN_SET_REF_CODE]:
				data?.[LOYALTY_PROGRAM_FIELDS.ME]?.[
					LOYALTY_PROGRAM_FIELDS.CAN_SET_REF_CODE
				] || false,
			[LOYALTY_PROGRAM_FIELDS.REF_CODE]:
				data?.[LOYALTY_PROGRAM_FIELDS.ME]?.[LOYALTY_PROGRAM_FIELDS.REF_CODE] ||
				"",
		},
	};
};

export default convertMyReferralSystem;
